import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'lib-ui-version-update-modal',
  templateUrl: './version-update-modal.component.html',
  styleUrls: ['./version-update-modal.component.scss']
})
export class VersionUpdateModalComponent implements OnInit, OnChanges {
  @Input() visible = false;
  @Input() currentVersion = '';
  @Input() newVersion = '';
  @Input() isRollback = false;
  @Input() appName = 'Application';

  @Output() accept = new EventEmitter<void>();
  @Output() modalClose = new EventEmitter<void>();

  isPortalMode = false;

  ngOnInit(): void {
    this.updatePortalMode();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appName']) {
      this.updatePortalMode();
    }
  }

  private updatePortalMode(): void {
    this.isPortalMode = this.appName.toLowerCase().includes('portal');
  }

  onVersionUpdateAccept(): void {
    this.accept.emit();
  }

  onVersionUpdateModalClose(): void {
    this.modalClose.emit();
  }
}
